(() => {
  const selector = '[data-ce-terms-checkbox]';
  const getBox = (form) => Array.from(form.elements).find(el => el.matches?.(selector));
  const showError = (box) => {
    const error = document.getElementById(box.getAttribute('aria-describedby'));
    if (error) error.hidden = false;
    box.setAttribute('aria-invalid', 'true');
  };
  document.addEventListener('invalid', (event) => {
    if (!event.target.matches?.(selector)) return;
    event.preventDefault();
    showError(event.target);
    event.target.focus();
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.submitter?.name !== 'checkout') return;
    const box = getBox(event.target);
    if (!box || box.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showError(box);
    box.focus();
  }, true);
  document.addEventListener('change', (event) => {
    const box = event.target;
    if (!box.matches?.(selector)) return;
    box.removeAttribute('aria-invalid');
    const error = document.getElementById(box.getAttribute('aria-describedby'));
    if (error) error.hidden = true;
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll(selector).forEach(box => { box.checked = false; });
  });
})();
